export const RETURN_SYMBOL = "[return]";
